import React from "react";

import Image from "next/image";

import FigureImage from "public/images/enerflo-unlock-advanced-reporting-features.png";

import Heading from "components/heading";

import HeroSection from "../../hero-section";

const title = "Dominate with AI Insights";

const AiInsights = () => (
  <HeroSection title={title} className="sm:py-16 lg:py-20">
    <div className="grow flex flex-col items-center">
      <HeroSection.Content className="w-full md:text-center mb-16">
        <HeroSection.Header>
          <Heading tag="h2">{title}</Heading>
        </HeroSection.Header>
        <HeroSection.Description>
          For organizations wanting more control over their data and advanced AI features to boost them to the next
          level, Enerflo offers additional next-level features for an additional fee.
        </HeroSection.Description>
      </HeroSection.Content>
      <HeroSection.Content className="w-full flex flex-col text-left md:flex-row md:items-center gap-x-10 gap-y-8">
        <div className="flex-1 space-y-6">
          <p className="text-lg">
            Unlock custom dashboards, predictive insights, and AI-driven answers—built to give you the ultimate edge.
          </p>
          <ul className="list-disc list-outside space-y-1 ml-4">
            <li>
              <strong>AI Chat</strong> – Ask questions & get instant answers using natural language
            </li>
            <li>
              <strong>Custom Reports</strong> – Build your own dashboards the way you want
            </li>
            <li>
              <strong>Custom Data</strong> – Integrate other sources beyond Enerflo
            </li>
            <li>
              <strong>Benchmarking</strong> – See how you stack up against peers
            </li>
            <li>
              <strong>Forecasting</strong> – Prediction scores & future projections
            </li>
            <li>
              <strong>Alerts</strong> – Notifications when key metrics change
            </li>
          </ul>

          <p>And we are just getting started…</p>
        </div>

        <figure className="flex-1 w-full xs:w-4/5 sm:w-3/4 md:w-full mx-auto">
          <Image
            src={FigureImage}
            alt="Enerflo Reporting Suite: Unlock advanced AI features."
            layout="responsive"
            quality={100}
            placeholder="blur"
            className="crispImage"
            sizes="(min-width: 768px) 50vw, 100vw"
          />
        </figure>
      </HeroSection.Content>
    </div>
  </HeroSection>
);

export default AiInsights;
